/**
 * Tons semânticos da interface. Cada domínio (status de vaga, estado de projeto,
 * negociação...) mapeia seus valores para um tom; nenhuma tela escolhe cor
 * direto. As cores vivem em index.css (--tone-*), então acompanham o tema.
 */
export const TONES = ["neutral", "info", "success", "warning", "danger", "accent", "ai"] as const;

export type Tone = (typeof TONES)[number];

/** Fundo suave + texto + borda: selos, chips, avisos. */
export const toneSoftClasses: Record<Tone, string> = {
  neutral: "bg-tone-neutral-bg text-tone-neutral-fg border-tone-neutral-border",
  info: "bg-tone-info-bg text-tone-info-fg border-tone-info-border",
  success: "bg-tone-success-bg text-tone-success-fg border-tone-success-border",
  warning: "bg-tone-warning-bg text-tone-warning-fg border-tone-warning-border",
  danger: "bg-tone-danger-bg text-tone-danger-fg border-tone-danger-border",
  accent: "bg-tone-accent-bg text-tone-accent-fg border-tone-accent-border",
  ai: "bg-tone-ai-bg text-tone-ai-fg border-tone-ai-border",
};

/** Cor cheia do tom: pontos, barras de progresso, bordas de destaque. */
export const toneSolidClasses: Record<Tone, string> = {
  neutral: "bg-tone-neutral-fg",
  info: "bg-tone-info-fg",
  success: "bg-tone-success-fg",
  warning: "bg-tone-warning-fg",
  danger: "bg-tone-danger-fg",
  accent: "bg-tone-accent-fg",
  ai: "bg-tone-ai-fg",
};

/** Só o texto no tom, para números e rótulos sem fundo. */
export const toneTextClasses: Record<Tone, string> = {
  neutral: "text-tone-neutral-fg",
  info: "text-tone-info-fg",
  success: "text-tone-success-fg",
  warning: "text-tone-warning-fg",
  danger: "text-tone-danger-fg",
  accent: "text-tone-accent-fg",
  ai: "text-tone-ai-fg",
};

/** Cor do tom para gráficos (recharts recebe string de cor, não classe). */
export function toneColor(tone: Tone): string {
  return `hsl(var(--tone-${tone}-fg))`;
}
